// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"c4467f5f","outerContainer":"_6bd506e9","secondaryToolbar":"c82dd4e9","doorHangerRight":"cf5a8ead","toolbarContainer":"_977742fa","toolbarViewerMiddle":"_1f6126f1","progressBar":"_1f09159b","back-to-application":"cbd0d9ac","root":"_4232ef76","name":"_9ab77171","strong":"_88385c3b","meta":"c2b624c2","noAvatar":"_91a1a974","noMeta":"d8e847fd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Healthboard/Components/NameWithAvatar/styles.styl
// module id = 4975
// module chunks = 39